<main class="pv2-global-additional">
  <header class="pv2-global-additional__header" *ngIf="!loading && group">
    <button type="button" class="pv2-global-additional__back" (click)="goBack()">
      <span class="fa fa-arrow-left"></span>
      <span>Adicionais</span>
    </button>

    <div class="pv2-global-additional__identity">
      <span class="pv2-global-additional__eyebrow">Editor de adicional</span>
      <div class="pv2-global-additional__title-row">
        <h1>{{ group.name }}</h1>
        <span class="pv2-global-additional__usage"
              [class.is-exclusive]="sharedProductNames.length === 1"
              [class.is-shared]="sharedProductNames.length > 1">
          {{ usageLabel }}
        </span>
      </div>
      <p>{{ group.options.length }} {{ group.options.length === 1 ? 'opção' : 'opções' }}</p>
    </div>

    <div class="pv2-salvamento" [class.is-pendente]="temAlteracaoPendente"
         [class.is-salvando]="estadoSalvamento === 'saving'">
      <span class="pv2-salvamento__estado" role="status">
        <span class="pv2-salvamento__ponto" aria-hidden="true"></span>
        {{ rotuloSalvamento }}
      </span>
      <button type="button" class="pv2-salvamento__btn" *ngIf="temAlteracaoPendente"
              (click)="salvarAgora()">
        Salvar agora
      </button>
    </div>
  </header>

  <nav class="pv3-tabs" *ngIf="group && !loading" aria-label="Seções do adicional">
    <button type="button" [class.is-active]="aba === 'compartilhados'" [attr.aria-current]="aba === 'compartilhados' ? 'page' : null" (click)="aba = 'compartilhados'">Dados compartilhados</button>
    <button type="button" [class.is-active]="aba === 'produtos'" [attr.aria-current]="aba === 'produtos' ? 'page' : null" (click)="aba = 'produtos'">Produtos vinculados ({{ regras.length }})</button>
  </nav>

  <!-- Renderiza mesmo sem vínculo nenhum: é justamente o caso que mais precisa da ação. -->
  <section class="pv2-global-additional__impact pv3-impact"
           [class.is-alerta]="sharedProductNames.length > 1"
           *ngIf="!loading && group && aba === 'compartilhados' && !avisoCompartilhadoFechado">
    <div>
      <span class="fa" [ngClass]="iconeVinculo"></span>
      <div>
        <strong>{{ tituloVinculo }}</strong>
        <p>Nome, opções e configurações desta aba valem para todos os produtos vinculados.</p>
      </div>
      <button type="button" class="pv2-global-additional__vincular"
              [disabled]="!canEditStructure"
              [attr.title]="canEditStructure ? null : 'A estrutura dos adicionais é controlada pelo catálogo da rede.'"
              (click)="abraSeletor()">
        <span class="fa fa-link"></span>
        Vincular a produtos
      </button>
    </div>
    <div class="pv2-global-additional__product-chips" *ngIf="sharedProductNames.length">
      <span *ngFor="let name of sharedProductNames"><span class="fa fa-cube" aria-hidden="true"></span>{{ name }}</span>
    </div>
    <button type="button" class="pv3-impact-close" aria-label="Fechar aviso de alterações compartilhadas"
            title="Fechar aviso" (click)="avisoCompartilhadoFechado = true">
      <span class="fa fa-times" aria-hidden="true"></span>
    </button>
  </section>

  <div class="pv2-overlay-vinculo" *ngIf="seletorAberto" (click)="fecheSeletor()"></div>
  <aside class="pv2-folha-vinculo" *ngIf="seletorAberto" role="dialog" aria-modal="true"
         aria-labelledby="pv2-folha-vinculo-titulo">
    <header class="pv2-folha-vinculo__topo">
      <div>
        <h2 id="pv2-folha-vinculo-titulo">Vincular a produtos</h2>
        <p>{{ group?.name }} passa a aparecer nos produtos marcados. É o mesmo grupo, não uma cópia.</p>
      </div>
      <button type="button" class="pv2-folha-vinculo__fechar" (click)="fecheSeletor()" aria-label="Fechar">
        <span class="fa fa-times"></span>
      </button>
    </header>

    <div class="pv2-folha-vinculo__corpo">
      <app-seletor-produtos-v2 *ngIf="!resultadoVisivel"
        [empresa]="empresa"
        [jaVinculados]="idsVinculados"
        [podeEditar]="canEditStructure"
        [ocupado]="vinculando"
        rotuloAcao="Vincular a"
        (confirmou)="vinculeAosProdutos($event)"
        (cancelou)="fecheSeletor()">
      </app-seletor-produtos-v2>

      <div class="pv2-resultado-vinculo" *ngIf="resultadoVisivel">
        <div class="pv2-resultado-vinculo__ok" *ngIf="vinculadosComSucesso">
          <span class="fa fa-check-circle"></span>
          <div>
            <strong>{{ vinculadosComSucesso }} {{ vinculadosComSucesso === 1 ? 'produto vinculado' : 'produtos vinculados' }}</strong>
            <p *ngIf="virouCompartilhado">
              Nome e opções são compartilhados entre os {{ sharedProductNames.length }} produtos. Obrigatoriedade e limites são definidos por produto.
            </p>
          </div>
        </div>

        <div class="pv2-resultado-vinculo__falhas" *ngIf="vinculosFalhos.length">
          <strong>{{ vinculosFalhos.length }} {{ vinculosFalhos.length === 1 ? 'produto ficou' : 'produtos ficaram' }} sem o vínculo</strong>
          <ul>
            <li *ngFor="let falha of vinculosFalhos">
              <span class="pv2-resultado-vinculo__produto">{{ falha.product.name }}</span>
              <span class="pv2-resultado-vinculo__motivo">{{ falha.error }}</span>
            </li>
          </ul>
        </div>

        <div class="pv2-resultado-vinculo__acoes">
          <button type="button" class="pv2-ghost-btn" (click)="fecheSeletor()">Fechar</button>
          <button type="button" class="pv2-ghost-btn" *ngIf="vinculosFalhos.length"
                  [disabled]="vinculando" (click)="tenteVinculosFalhos()">
            <span class="fa fa-spinner fa-spin" *ngIf="vinculando"></span>
            Tentar de novo
          </button>
          <button type="button" class="pv2-primary-btn" (click)="voltarAoSeletor()">Vincular a mais</button>
        </div>
      </div>
    </div>
  </aside>

  <section class="pv2-global-additional__loading" *ngIf="loading">
    <span class="fa fa-spinner fa-spin"></span>
    <p>Carregando adicional...</p>
  </section>

  <section class="pv2-global-additional__error" *ngIf="!loading && errorMessage">
    <span class="fa fa-exclamation-circle"></span>
    <h2>Não foi possível abrir o adicional</h2>
    <p>{{ errorMessage }}</p>
    <div>
      <button type="button" (click)="goBack()">Voltar</button>
      <button type="button" class="is-primary" (click)="load()">Tentar novamente</button>
    </div>
  </section>

  <section class="pv2-global-additional__editor" [hidden]="aba !== 'compartilhados'" *ngIf="!loading && !errorMessage && editor && group">
    <app-tela-editor-adicional-v2
      [standalone]="true"
      [layoutV3]="true"
      [ativo]="aba === 'compartilhados'"
      (produtosRequested)="aba = 'produtos'"
      [editor]="editor"
      [empresa]="empresa"
      [podeEditar]="canEditStructure"
      [podeEditarPrecos]="canEditPrices"
      [podeEditarDisponibilidade]="canEditAvailability"
      [podeEditarExibicaoOpcoes]="canEditOptionDisplay"
      [groupId]="group.id"
      [mode]="'edit'"
      [requestedOptionMode]="requestedOptionMode"
      (closeRequested)="goBack()"
      (actionBarStateChange)="onEstadoSalvamento($event)"
      (groupSaved)="onGroupSaved($event)"
      (groupDeleted)="onGroupDeleted()">
    </app-tela-editor-adicional-v2>
  </section>

  <section *ngIf="aba === 'produtos' && !loading && group" class="pv3-products">
    <p class="pv3-notice"><span class="fa fa-info-circle"></span> Obrigatoriedade, mínimo e máximo valem somente para o produto editado.</p>
    <p class="pv3-notice" *ngIf="!canEditStructure">As regras são controladas pelo catálogo da rede.</p>
    <p class="pv3-notice" *ngIf="grupoKit">As regras de composição do kit continuam no editor de dados compartilhados.</p>
    <p *ngIf="carregandoRegras" role="status"><span class="fa fa-spinner fa-spin"></span> Carregando produtos...</p>
    <div *ngIf="erroRegras" class="pv3-error" role="alert">{{ erroRegras }} <button type="button" (click)="carregueRegras()">Tentar novamente</button></div>
    <div class="pv3-grid">
      <article class="pv3-card">
        <header class="pv3-card-head">
          <span class="pv3-icon fa fa-shield-alt"></span>
          <div><h2>Regras por produto</h2><p>Personalize este adicional em cada produto</p></div>
          <button type="button" class="pv3-button" [disabled]="!canEditStructure" (click)="abraSeletor()"><span class="fa fa-link"></span> Vincular a produtos</button>
        </header>
        <label class="pv3-search"><span class="fa fa-search"></span><input type="search" [(ngModel)]="pesquisa" placeholder="Pesquisar produtos..." aria-label="Pesquisar produtos"></label>
        <div class="pv3-table-scroll">
          <table>
            <thead><tr><th>Produto</th><th>Obrigatório</th><th>Mínimo</th><th>Máximo</th><th><span class="sr-only">Ações</span></th></tr></thead>
            <tbody>
              <tr *ngFor="let regra of regrasFiltradas" [class.is-selected]="selecionado?.id === regra.id">
                <td>
                  <button type="button" class="pv3-product" (click)="selecionado = regra"><span class="fa fa-cube"></span>{{ regra.nome }}</button>
                  <div class="pv3-row-status" aria-live="polite">
                    <span class="pv3-badge" *ngIf="selecionado?.id === regra.id">Em edição</span>
                    <span *ngIf="regra.salvando">Salvando...</span><span class="is-pending" *ngIf="regra.pendente && !regra.salvando">Pendente</span>
                  </div>
                  <div *ngIf="regra.erro" class="pv3-error" role="alert">{{ regra.erro }} <button type="button" (click)="salveRegra(regra)" [disabled]="regra.salvando">Tentar novamente</button></div>
                </td>
                <td><label class="pv3-switch"><input type="checkbox" [(ngModel)]="regra.obrigatorio" (ngModelChange)="altereRegra(regra, 'obrigatorio')" [disabled]="!canEditStructure || grupoKit || regra.salvando" [attr.aria-label]="'Obrigatório em ' + regra.nome"><span></span></label></td>
                <td><input class="pv3-number" type="number" min="0" step="1" [(ngModel)]="regra.qtdMinima" (ngModelChange)="altereRegra(regra, 'minimo')" [disabled]="!canEditStructure || grupoKit || regra.salvando || regra.tipo === 'escolha-simples'" [attr.aria-label]="'Mínimo em ' + regra.nome" [attr.aria-invalid]="regra.erro ? true : null"></td>
                <td><input class="pv3-number" type="number" [min]="regra.qtdMinima || 1" step="1" placeholder="Sem limite" [(ngModel)]="regra.qtdMaxima" (ngModelChange)="altereRegra(regra, 'maximo')" [disabled]="!canEditStructure || grupoKit || regra.salvando || regra.tipo === 'escolha-simples'" [attr.aria-label]="'Máximo em ' + regra.nome" [attr.aria-invalid]="regra.erro ? true : null"></td>
                <td><button type="button" class="pv3-button pv3-unlink" [disabled]="!canEditStructure || removendo || regra.salvando" (click)="remover = regra" [attr.aria-label]="'Remover adicional de ' + regra.nome"><span class="fa fa-unlink"></span> {{ regras.length === 1 && !group.shared ? 'Excluir' : 'Desvincular' }}</button></td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="pv3-empty" *ngIf="!regrasFiltradas.length && !carregandoRegras">{{ pesquisa ? 'Nenhum produto encontrado.' : 'Este adicional ainda não está vinculado a um produto.' }}</p>
        <footer class="pv3-table-footer"><strong>{{ regras.length }} produtos vinculados</strong><span><span class="fa fa-unlink"></span> Desvincular remove o adicional apenas deste produto.</span></footer>
      </article>
      <aside class="pv3-side" *ngIf="selecionado as produto">
        <article class="pv3-card pv3-context"><small>Produto em edição</small><strong><span class="pv3-icon fa fa-cube"></span>{{ produto.nome }}</strong><p>Regras somente deste produto</p></article>
        <div *ngIf="!grupoKit">
          <p class="pv3-eyebrow"><span class="fa fa-eye"></span> Visão do cliente</p>
          <article class="pv3-card pv3-preview">
            <h3>{{ editorAdicional?.groupDraft?.name || group.name }}</h3>
            <span class="pv3-badge" [class.is-optional]="!produto.obrigatorio">{{ produto.obrigatorio ? 'Obrigatório' : 'Opcional' }}</span>
            <p>{{ produto.obrigatorio ? 'Selecione de ' + produto.qtdMinima + (produto.qtdMaxima == null ? ' ou mais opções' : ' a ' + produto.qtdMaxima + ' opções') : (produto.qtdMaxima == null ? 'Selecione opções' : 'Selecione até ' + produto.qtdMaxima + ' opções') }}</p>
            <div class="pv3-preview-options"><label *ngFor="let opcao of opcoesPreview"><input [type]="group.type === 'single' ? 'radio' : 'checkbox'" name="preview-v3" disabled> {{ opcao.name }}</label><p *ngIf="!opcoesPreview.length">Nenhuma opção ativa.</p></div>
            <footer><span class="fa fa-eye"></span> Prévia atualizada enquanto você edita</footer>
          </article>
        </div>
        <article class="pv3-card pv3-summary" *ngIf="!grupoKit">
          <header><span class="pv3-icon fa fa-clipboard-list"></span><div><h3>Resumo e ações</h3><p>Revise as regras deste produto</p></div></header>
          <dl><div><dt>Obrigatório</dt><dd>{{ produto.obrigatorio ? 'Sim' : 'Não' }}</dd></div><div><dt>Mínimo</dt><dd>{{ produto.qtdMinima }}</dd></div><div><dt>Máximo</dt><dd>{{ produto.qtdMaxima == null ? 'Sem limite' : produto.qtdMaxima }}</dd></div></dl>
          <p>Alterações aplicadas apenas em {{ produto.nome }}.</p><button type="button" class="pv3-button" (click)="abraProduto()"><span class="fa fa-external-link"></span> Abrir produto</button>
        </article>
        <article class="pv3-card pv3-shared"><h3><span class="fa fa-link"></span> Dados compartilhados</h3><p>Nome, opções, seleção e cobrança continuam compartilhados.</p><button type="button" (click)="aba = 'compartilhados'">Editar dados compartilhados <span class="fa fa-arrow-right"></span></button></article>
      </aside>
    </div>
    <footer class="pv3-actions"><button type="button" class="pv3-button" (click)="goBack()"><span class="fa fa-arrow-left"></span> Voltar</button><button type="button" class="pv3-button" (click)="salvarAgora()"><span class="fa fa-save"></span> Salvar</button><button type="button" class="pv3-button is-primary" (click)="salvarEFechar()"><span class="fa fa-check"></span> Salvar e Fechar</button><span>Salvamento automático</span></footer>
  </section>
  <kendo-dialog *ngIf="remover" title="Remover adicional do produto" (close)="!removendo && (remover = null)" [width]="440">
    <p *ngIf="regras.length > 1 || group?.shared">Desvincular <strong>{{ group?.name }}</strong> de <strong>{{ remover.nome }}</strong>? Os demais produtos continuam com o adicional.</p>
    <p *ngIf="regras.length === 1 && !group?.shared">Este adicional é exclusivo de {{ remover.nome }}. Ao excluir, suas opções também serão removidas.</p>
    <kendo-dialog-actions><button kendoButton [disabled]="removendo" (click)="remover = null">Cancelar</button><button kendoButton [disabled]="removendo" (click)="confirmeRemocao()">{{ removendo ? 'Removendo...' : 'Remover deste produto' }}</button></kendo-dialog-actions>
  </kendo-dialog>
</main>
